// extracted by mini-css-extract-plugin
export default {"LoginCalendar":"loginCalendar_LoginCalendar__+K26A","calendar":"loginCalendar_calendar__+YIZh"};